import { render, staticRenderFns } from "./GuardianContact.vue?vue&type=template&id=78bec5e2"
import script from "./GuardianContact.vue?vue&type=script&lang=js"
export * from "./GuardianContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports